import { trackError } from 'helpers/track_error';
import type { FC } from 'react';
import { useLocation } from 'react-router-dom';

interface noMatchProps {
  packageName: string;
}

const NoMatch: FC<noMatchProps> = ({ packageName }) => {
  const location = useLocation();
  trackError({
    error: new Error(`[${packageName}-ReactRouter] 404 - ${location.pathname}`),
  });
  window.location.href = '/';
  return null;
};

export default NoMatch;
